Ext.define('SA.view.combolocation.CombinationLocationWindow', {
    alias: 'widget.combination-location-window',
    extend: 'Ext.Container',

    autoShow: true,
    baseCls: 'sa-combo-location-window',
    floating: true,
    height: 603,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',
    width: 808,

    layout: {
        type: 'vbox',
        align: 'stretch'
    },

    items: [
        {
            xtype: 'container',

            items: [
                {
                    xtype: 'close-button'
                }, {
                    xtype: 'component',
                    cls: 'sa-combo-location-window-heading',
                    itemId: 'heading',
                    tpl: '<div class="sa-combo-location-window-title">{title}</div>'
                }
            ],

            layout: {
                type: 'auto'
            }
        }, {
            xtype: 'container',
            flex: 1,
            margin: '0 0 24',

            layout: {
                align: 'stretch',
                type: 'hbox'
            },

            items: [
                {
                    xtype: 'container',
                    flex: 1,

                    layout: {
                        align: 'stretch',
                        type: 'vbox'
                    },

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-combo-location-window-step',

                            html: [
                                '<svg><use href="#sa-icon-step-1"></use></svg>',
                                '<div class="sa-combo-location-window-step-text">Name your combination location</div>'
                            ]
                        }, {
                            xtype: 'sa-text-field',
                            emptyText: 'Enter a name',
                            itemId: 'name',
                            margin: '18 32 0'
                        }
                    ]
                }, {
                    xtype: 'component',
                    cls: 'sa-combo-location-window-vertical-separator',
                    margin: '50 0 0'
                }, {
                    xtype: 'container',
                    flex: 1,

                    layout: {
                        align: 'stretch',
                        type: 'vbox'
                    },

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-combo-location-window-step',

                            html: [
                                '<svg><use href="#sa-icon-step-2"></use></svg>',
                                '<div class="sa-combo-location-window-step-text">Select one or more locations</div>'
                            ]
                        }, {
                            allowCustomLocations: false,
                            allowRecentListCustomLocationMenuItems: false,
                            margin: '18 32 10',
                            xtype: 'location-search-field',

                            updateFilters() {
                                var locationSeries = this.selected,
                                    locations;

                                if (locationSeries && locationSeries.length) {
                                    locations = SA.data.LocationsCache.get(locationSeries);

                                    let geographicReleases = Ext.Array.intersect(...locations.map(location => location.geographicReleases));

                                    this.setGeographicUnits(locations[0].geographicUnit);
                                    this.setGeographicReleases(geographicReleases);
                                }
                                else {
                                    let countryUnit = SA.AppController.getCurrentProject().getCountryModel().getGeographicUnit(),
                                        discoverableUnits = SA.AppController.getCurrentProject().getDiscoverableGeographicUnits(),
                                        units = discoverableUnits.filter(unit => unit !== countryUnit);

                                    this.setGeographicUnits(units);
                                    this.clearGeographicReleases();
                                }
                            },

                            xhooks: {
                                beforeRender() {
                                    this.getRecentList().checkMarkTooltip = 'Added to combination';

                                    this.updateFilters();

                                    this.setCensusRelease(this.up('combination-location-window').getCensusRelease());

                                    this.callParent();
                                },

                                setSelected(locationSeries) {
                                    this.callParent([locationSeries]);

                                    this.updateFilters();
                                }
                            }
                        }, {
                            xtype: 'selected-locations-list',
                            flex: 1,
                            margin: '0 32'
                        }
                    ]
                }
            ]
        }, {
            xtype: 'container',
            cls: 'sa-combo-location-window-footer',

            items: [
                {
                    xtype: 'sa-button',
                    disabled: true,
                    itemId: 'doneBtn',
                    text: 'Save',
                    ui: 'primary',
                    width: 118,

                    handler() {
                        var btn = this,
                            win = btn.up('combination-location-window');

                        btn.disable();

                        win.save();
                    }
                }, {
                    xtype: 'sa-button',
                    text: 'Cancel',
                    width: 118,

                    handler() {
                        this.up('combination-location-window').destroy();
                    }
                }
            ],

            layout: {
                type: 'hbox',
                pack: 'center'
            }
        }
    ],

    initComponent() {
        var title = this.title;

        this.callParent();

        this.nameField = this.down('#name');
        this.searchField = this.down('location-search-field');
        this.locationsList = this.down('selected-locations-list');
        this.doneBtn = this.down('#doneBtn');

        this.nameField.on('change', this.refreshDoneButton, this);
        this.searchField.on('select', this.onSelectLocation, this);
        this.locationsList.on('change:locations', this.onChangeLocations, this);

        this.down('#heading').update({title});
    },

    getCensusRelease() {
        return this.combo ? this.combo.censusRelease : SA.AppController.getCurrentModelCensusRelease();
    },

    getNameFieldValue() {
        return this.nameField.getValue().trim();
    },

    onChangeLocations() {
        var searchField = this.searchField,
            locationsList = this.locationsList;

        searchField.setSelected(locationsList.getLocations());

        this.refreshDoneButton();
    },

    onSelectLocation(field, locationSeries) {
        this.locationsList.addLocation(locationSeries);
    },

    refreshDoneButton() {
        var btn = this.doneBtn,
            locationsList = this.locationsList,
            name = this.getNameFieldValue(),
            locationSeries = locationsList.getLocations();

        btn.setDisabled(!name || !locationSeries.length);
    }
});